module.exports = "images/8ans.11e3c2b1.png";